import React, {useState} from "react";

import "./ChangeConceptCapture.css";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {createChangeConcept, updateChangeConcept} from "../../../../services/ChangeConceptService";

export const ChangeConceptCapture = ({context, navigateTo, navigateBack, showToaster, setSpinnerText}) => {

    const [externalReference] = useState(context.selectedChangeConcept ? context.selectedChangeConcept.externalReference : null);
    const [changeConcept, setChangeConcept] = useState(context.selectedChangeConcept ? context.selectedChangeConcept.changeIdeaConcept : null);
    const [active, setActive] = useState(context.selectedChangeConcept ? context.selectedChangeConcept.active : null);

    const handleClick = async () => {
        const changeConceptToBeSaved = {externalReference, changeIdeaConcept: changeConcept, active};
        if (null === externalReference) {
            setSpinnerText("Creating Change Concept");
            const response = await createChangeConcept(context.username, changeConceptToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Change Concept");
            const response = await updateChangeConcept(context.username, changeConceptToBeSaved);
            handleResponse(response);
        }
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("changeConceptTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    return (
        <div className="change-concept-capture-container">
            <div className="change-concept-capture-form-container">
                <LeftLabelTextInput labelText="Change Concept:" handleChange={({target}) => {
                    setChangeConcept(target.value)
                }} defaultValue={changeConcept}/>
                <LeftLabelToggle labelText="Active:" active={active} setActive={setActive}/>
            </div>
            <div className="change-concept-capture-button-container">
                <StandardButton text={context.selectedChangeConcept ? "Update Change Concept" : "Add Change Concept"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    )
}
